import { render } from "./commonStatisticsBlock.vue?vue&type=template&id=e57539ae&scoped=true"
import script from "./commonStatisticsBlock.vue?vue&type=script&lang=js"
export * from "./commonStatisticsBlock.vue?vue&type=script&lang=js"

import "./commonStatisticsBlock.vue?vue&type=style&index=0&id=e57539ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57539ae"]])

export default __exports__